<div *ngIf="isAiMode && !single && productDialogPilot" class="bo-ai-photo-picker" ngx-dropzone [disableClick]="true" [accept]="acceptTypes" (change)="onSelect($event)">
  <div class="bo-ai-photo-studio" [class.bo-ai-photo-studio--filled]="filesUrl.length > 0" role="group" [attr.aria-label]="'bd_ai_photos' | translate" tabindex="-1" ngbAutofocus>
    <div class="bo-ai-photo-welcome" *ngIf="!filesUrl.length">
      <div class="bo-ai-photo-art" aria-hidden="true"><span class="bo-ai-photo-art__back"><i class="bi bi-image"></i></span><span class="bo-ai-photo-art__camera"><i class="bi bi-camera"></i></span><span class="bo-ai-photo-art__spark"><i class="bi bi-stars"></i></span></div>
      <h3>{{ 'bd_ai_photo_start' | translate }}</h3>
      <p>{{ 'bd_ai_photo_tip' | translate }}</p>
    </div>
    <div class="bo-ai-photos" *ngIf="filesUrl.length">
      <div class="bo-ai-photo" *ngFor="let file of filesUrl; let index = index">
        <img *ngIf="file.url && !isBroken(file.url)" [src]="file.url" alt="" (error)="onImageError(file.url)">
        <i *ngIf="file.url && isBroken(file.url)" class="bi bi-image" aria-hidden="true"></i>
        <span *ngIf="file.loading || !file.url" class="bo-ai-photo-loading"><span class="bo-dialog__spinner" role="status" [attr.aria-label]="'loading' | translate"></span></span>
        <button *ngIf="!file.loading" type="button" (click)="onRemove(index); $event.stopPropagation()" [disabled]="aiSelectionBusy" [attr.aria-label]="('bd_ai_remove_photo' | translate:{index: index + 1})"><i class="bi bi-x-lg" aria-hidden="true"></i></button>
        <span *ngIf="index === 0 && !file.loading" class="bo-ai-primary-photo">{{ 'bd_ai_main_photo' | translate }}</span>
      </div>
    </div>
    <div class="bo-ai-photo-actions" *ngIf="!maxFiles || filesUrl.length < maxFiles">
      <button type="button" class="bo-dialog__button bo-dialog__button--primary bo-ai-photo-primary bo-ai-photo-camera" [disabled]="aiSelectionBusy || activeUploads > 0" (click)="pilotCameraInput.click(); $event.stopPropagation()"><i class="bi bi-camera" aria-hidden="true"></i>{{ (filesUrl.length ? 'bd_ai_take_another_photo' : 'bd_ai_take_photo') | translate }}</button>
      <button type="button" class="bo-dialog__button bo-dialog__button--primary bo-ai-photo-primary bo-ai-photo-desktop" [disabled]="aiSelectionBusy || activeUploads > 0" (click)="pilotFileInput.click(); $event.stopPropagation()"><i class="bi bi-plus-lg" aria-hidden="true"></i>{{ (filesUrl.length ? 'bd_ai_add_photo' : 'bd_ai_upload_photos') | translate }}</button>
      <div class="bo-ai-photo-alternatives">
        <button type="button" class="bo-dialog__button bo-ai-photo-gallery" [disabled]="aiSelectionBusy || activeUploads > 0" (click)="pilotFileInput.click(); $event.stopPropagation()"><i class="bi bi-image" aria-hidden="true"></i>{{ 'bd_ai_from_gallery' | translate }}</button>
        <button type="button" class="bo-dialog__button bo-ai-photo-library" [disabled]="aiSelectionBusy || activeUploads > 0" (click)="openLibraryPicker($event)"><i class="bi bi-folder2-open" aria-hidden="true"></i>{{ 'bd_ai_store_library' | translate }}</button>
      </div>
      <span class="bo-ai-photo-drop-hint">{{ 'bd_ai_drop_hint' | translate }}</span>
    </div>
    <p *ngIf="aiSelectionBusy || activeUploads > 0" class="bo-ai-photo-feedback" role="status"><span class="bo-dialog__spinner" aria-hidden="true"></span>{{ 'bd_ai_uploading' | translate }}</p>
    <p *ngIf="maxFiles && filesUrl.length >= maxFiles && !aiSelectionBusy && !activeUploads" class="bo-ai-photo-feedback bo-ai-photo-feedback--ready" role="status"><i class="bi bi-check2-circle" aria-hidden="true"></i>{{ 'bd_ai_photos_ready' | translate:{count: filesUrl.length} }}</p>
    <input #pilotFileInput type="file" hidden accept="image/*" multiple (change)="onPilotFilesSelected($event)">
    <input #pilotCameraInput type="file" hidden accept="image/*" capture="environment" (change)="onPilotFilesSelected($event)">
  </div>
</div>
<!--#######----AI MODE-----#######-->
<div *ngIf="isAiMode && !single && !productDialogPilot" class="ai-dropzone-container">
  <div class="dropzone-area" [class.drag-over]="isDragOver" [class.has-files]="filesUrl && filesUrl.length > 0"
    ngx-dropzone [disableClick]="allowLibraryPick" (click)="onZoneClick($event)"
    [accept]="acceptTypes" (change)="onSelect($event)" (dragover)="isDragOver = true"
    (dragleave)="isDragOver = false" (drop)="isDragOver = false">

    <!-- Empty state -->
    <ngx-dropzone-label *ngIf="!(filesUrl && filesUrl.length > 0)">
      <div class="ai-upload-content">
        <div class="ai-upload-icon">
          <i class="bi bi-cloud-arrow-up"></i>
        </div>
        <p class="ai-upload-text">{{'ai_modal_upload_photos' | translate}}</p>
        <p class="ai-upload-hint">{{'ai_creation_images_hint' | translate}}</p>
      </div>
    </ngx-dropzone-label>

    <!-- Files preview -->
    <div *ngIf="filesUrl && filesUrl.length > 0" class="ai-files-preview">
      <div class="ai-image-grid">
        <div *ngFor="let file of filesUrl; let i = index" class="ai-image-item" [class.is-uploading]="file.loading"
          [style.cursor]="file.url && !isBroken(file.url) ? 'pointer' : 'default'"
          (click)="openFile($event, file.url)">
          <!-- Show image if URL exists and is an image -->
          <img *ngIf="file.url && isImage(file.url) && !isBroken(file.url)" [src]="file.url" alt="Uploaded image"
            (error)="onImageError(file.url)" />

          <!-- El fichero ya no existe en el servidor: placeholder en vez del icono roto.
               El boton de borrar de mas abajo se sigue mostrando encima. -->
          <div *ngIf="file.url && isImage(file.url) && isBroken(file.url)" class="ai-file-icon ai-file-icon--broken">
            <i class="bi bi-image-alt"></i>
            <span class="broken-text">{{ 'ml_media_unavailable' | translate }}</span>
          </div>

          <!-- Show icon for PDF or other files in AI mode too -->
          <div *ngIf="file.url && !isImage(file.url)" class="ai-file-icon">
            <i class="bi" [class.bi-file-earmark-pdf]="isPdf(file.url)"
              [class.bi-file-earmark-text]="!isPdf(file.url)"></i>
          </div>

          <!-- Show placeholder when uploading and no URL yet -->
          <div *ngIf="!file.url || file.loading" class="ai-upload-placeholder">
            <span class="spinner-border spinner-border-sm text-primary"></span>
            <span class="upload-text">{{ 'loading' | translate }}</span>
          </div>
          <!-- Remove button (only show when not uploading) -->
          <button *ngIf="!file.loading" type="button" class="ai-remove-btn"
            (click)="onRemove(i); $event.stopPropagation()">
            <i class="bi bi-x"></i>
          </button>
        </div>
        <!-- Add more button -->
        <div class="ai-add-more" *ngIf="filesUrl.length < 5">
          <i class="bi bi-plus-lg"></i>
          <span>{{'ai_modal_add_more' | translate}}</span>
        </div>
      </div>
    </div>
  </div>
</div>

<!--#######----MULTIPLE (non-AI mode)-----#######-->
<div *ngIf="!single && !isAiMode" class="custom-dropzone" ngx-dropzone
  [disableClick]="allowLibraryPick" (click)="onZoneClick($event)"
  [accept]="acceptTypes" (change)="onSelect($event)"
  [class.is-invalid]="isInvalid || validationErrorMessage">
  <ngx-dropzone-label *ngIf="!(filesUrl.length > 0)">
    <div>
      <p class="grey">{{'dz_drop_images_here' | translate}} </p>
      <p class="primary">{{'dz_browse_from_device' | translate}}</p>
    </div>
    <i class="bi bi-file-earmark-arrow-up grey" style="font-size: 4rem;"></i>
  </ngx-dropzone-label>
  <app-custom-dropzone-preview *ngIf="filesUrl.length > 0" ngProjectAs="ngx-dropzone-preview" [filesUrl]="filesUrl"
    [imageSize]="imageConstraints" [allowReorder]="allowReorder" (reorderEvent)="onReorder($event)"
    (closeFileEvent)="onRemove($event)" (cancelUploadEvent)="onCancelUpload($event)"
    (aiEnhanceEvent)="aiEnhanceEvent.emit($event)">
  </app-custom-dropzone-preview>
</div>

<!-- Error message display for multiple files -->
<div *ngIf="!single && validationErrorMessage" class="invalid-feedback d-block mt-2">
  <i class="bi bi-exclamation-triangle-fill me-1"></i>
  {{ validationErrorMessage }}
</div>
<!-- Warning message display for multiple files -->
<div *ngIf="!single && validationWarningMessage" class="d-block mt-2 text-warning">
  <i class="bi bi-exclamation-circle me-1"></i>
  {{ validationWarningMessage }}
</div>

<!--#######----SINGLE-----#######-->

<div *ngIf="single" class="custom-single-dropzone" ngx-dropzone
  [disableClick]="allowLibraryPick" (click)="onZoneClick($event)"
  [accept]="acceptTypes" (change)="onSelect($event)" [multiple]="false"
  [class.is-invalid]="isInvalid || validationErrorMessage">
  <ngx-dropzone-label *ngIf="!(singleFile.value.length > 0) && !isSingleFileUploading">
    <div class="py-2">
      <p class="grey">{{'dz_drop_image_here' | translate}}</p>
    </div>
    <i class="bi bi-file-earmark-arrow-up font-medium-4"></i>
    <!--button type="button" class="btn btn-square bg-light-primary me-2 mb-1" >
      <i class="bi bi-box-arrow-in-down font-medium-4"></i>
    </!--button-->
    <!--i class="bi bi-box-arrow-in-down primary bg-primary bg-lighten-4 p-1 round square" style="font-size: '1.8rem'"></!--i-->
  </ngx-dropzone-label>

  <div *ngIf="isSingleFileUploading || isExternalLoading" class="single-upload-spinner">
    <span class="spinner-border text-light" role="status" aria-hidden="true"></span>
    <p class="mt-1 ms-2 grey">{{ 'uploading_file_please_wait' | translate }}</p>
  </div>


  <app-custom-dropzone-preview
    *ngIf="singleFile.value.length > 0 && !isSingleFileUploading && !isExternalLoading"
    ngProjectAs="ngx-dropzone-preview" [singleFileUrl]="singleFile" [imageSize]="imageConstraints"
    (closeFileEvent)="onRemoveSingle($event)">
  </app-custom-dropzone-preview>
</div>

<!-- Error message display for single file -->
<div *ngIf="single && imageConstraints && imageConstraints.required && this.imageConstraints.aspect_ratio"
  class="text-muted font-small-2 d-block mt-2">
  <i class="bi bi-info-triangle-fill me-1"></i>
  {{ 'recomended_image_size_ratio' | translate }} {{ imageConstraints.width }}×{{ imageConstraints.height }} px or ({{
  imageConstraints.aspect_ratio }})
</div>

<!-- Error message display for single file -->
<div *ngIf="single && validationErrorMessage" class="invalid-feedback d-block mt-2">
  <i class="bi bi-exclamation-triangle-fill me-1"></i>
  {{ validationErrorMessage }}
</div>
<!-- Warning message display for single file -->
<div *ngIf="single && validationWarningMessage" class="d-block mt-2 text-warning">
  <i class="bi bi-exclamation-circle me-1"></i>
  {{ validationWarningMessage }}
</div>

<!--div *ngIf="isCropping" class="cropper-area p-3 border rounded shadow-sm">
      <h4>Recorta tu imagen</h4>
      
      <image-cropper
          [imageChangedEvent]="imageChangedEvent"
          [maintainAspectRatio]="true"
          [aspectRatio]="1 / 1" 
          format="png"
          [resizeToWidth]="250"
          (imageCropped)="imageCropped($event)"
          style="width: 100%; height: 350px;"
      ></image-cropper>

      <div class="d-flex justify-content-between mt-3">
          <button class="btn btn-secondary" (click)="onCropCancel()">Cancelar</button>
          <button 
              class="btn btn-success" 
              
              (click)="onCropAccept()"
          >
              Aceptar Recorte
          </button>
      </div>
  <div-->
